export default {
  'name': '@okta/okta-angular-root',
  'version': '0.1.0',
  'authJSMinSupportedVersion': '5.3.1'
};
